import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AccountService } from 'src/app/services/account.service';
import { OtherService } from 'src/app/services/other.service';
import { ITrip_Payment } from './Interfaces';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})

export class PaymentComponent implements OnInit {
  trip_Obj!: ITrip_Payment | any;
  bClipboard: boolean = false;

  mdl_Auth: FormGroup = this._fb.group({
    strAuthority: new FormControl(''),
    strStatus: new FormControl(''),
  });
  mdl_Success: FormGroup = this._fb.group({
    iTaxiLon_User: this._utility.getLocalStorage().Id,
    strSession: this._utility.getLocalStorage().session,
  })

  constructor(
    private route: ActivatedRoute,
    private _fb: FormBuilder,
    private _service: AccountService,
    private _utility: OtherService,
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((query: { Authority: string, Status: string }) => {
      this.mdl_Auth.patchValue({
        strAuthority: query.Authority,
        strStatus: query.Status
      })

      this._service.checkPayment(query).subscribe((data: ITrip_Payment | any) => {
        let res = JSON.parse(data.toString());
        this.trip_Obj = res;
      })
    })
  }

  clipboard(strText: string) {
    this.bClipboard = true;
    setTimeout(() => {
      this.bClipboard = false;
    }, 1500);

    var clipboard = navigator.clipboard;
    clipboard.writeText(strText).then(function () {
      console.log('Copied to clipboard successfully!');
    }, function () {
      console.error('Unable to write to clipboard. :-(');
    });
  }
  

}
